import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import strings from 'owa-strings/owa-mail-strings';

/**
 * Get the folder scope text
 * @param focusedViewFilter the focused view filter
 * @param folderDisplayName the folder display name
 * @returns the folder scope text, e.g Focused Inbox, Other Inbox, Sent Items, etc.
 */
export default function getFolderScopeText(
    focusedViewFilter: FocusedViewFilter,
    folderDisplayName: string
): string {
    switch (focusedViewFilter) {
        case FocusedViewFilter.Focused:
            return `${strings.otherViewFilterText} ${folderDisplayName}`;
        case FocusedViewFilter.Other:
            return `${strings.otherViewFilterText} ${folderDisplayName}`;
    }

    return folderDisplayName;
}
